import { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Question from "./assets/faq.png";

const Faq = () => {
  const [activeKey, setActiveKey] = useState("0");
  const [faqMessage, setFaqMessage] = useState("");
  const navigate = useNavigate();

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  const handleSend = () => {
    navigate("/contact", { state: { message: faqMessage } });
  };

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const faqData = [
    {
      q: "What kind of AI services do you provide?",
      a: "We provide end-to-end AI solutions including computer vision, automation, analytics, facial recognition, predictive modeling, and IoT integration.",
    },
    {
      q: "Can your models integrate with our existing cameras and systems?",
      a: "Yes. All our AI modules are designed for easy integration with your existing CCTV and IT infrastructure.",
    },
    {
      q: "Do you offer custom AI development?",
      a: "Absolutely. We tailor our models and dashboards according to your operational requirements.",
    },
    {
      q: "How secure is your AI system?",
      a: "We follow enterprise-grade security standards for data encryption, access control, and cloud management.",
    },
    {
      q: "Do you provide on-site deployment and support?",
      a: "Yes, our team provides on-site installation, training, and continuous technical support.",
    },
  ];

  return (
    <section
      style={{
        background: "linear-gradient(135deg, #dc94d5ff, #efe9e9ff, #a0d6f1ff)",
        padding: "60px 0",
      }}
    >
      <Container>
        <motion.h1
          className="text-center mt-4 fw-bold mb-5"
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: "2.8rem",
            letterSpacing: "0.5px",
            lineHeight: "1.3",
            textTransform: "uppercase",
            color: "black",
          }}
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false }}
        >
          FAQ's
        </motion.h1>

        <Row>
          {/* Accordion */}
          <Col md={6}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: false }}
            >
              <div className="faq-accordion">
                {faqData.map((item, idx) => (
                  <div
                    key={idx}
                    className={`accordion-item ${
                      activeKey === idx.toString() ? "active" : ""
                    }`}
                  >
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion(idx.toString())}
                    >
                      <span>{item.q}</span>
                      <span className="faq-icon">
                        {activeKey === idx.toString() ? "−" : "+"}
                      </span>
                    </div>
                    <div
                      className={`accordion-body ${
                        activeKey === idx.toString() ? "open" : ""
                      }`}
                    >
                      <div className="accordion-content">{item.a}</div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </Col>

          {/* Image + Textarea */}
          <Col md={6}>
            <div className="d-flex flex-column align-items-center">
              <motion.img
                src={Question}
                alt="question"
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  height: "200px",
                  filter:
                    "drop-shadow(0 0 8px #ff66cc) drop-shadow(0 0 12px #a855f7)",
                  marginBottom: "20px",
                }}
                animate={{
                  scale: [1, 1.03, 1],
                  filter: [
                    "drop-shadow(0 0 6px #ff66cc) drop-shadow(0 0 10px #a855f7)",
                    "drop-shadow(0 0 6px #ff66cc) drop-shadow(0 0 18px #a855f7)",
                    "drop-shadow(0 0 6px #ff66cc) drop-shadow(0 0 10px #a855f7)",
                  ],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
              <h3 className="text-center">Any Question</h3>
              <p className="text-center">
                You can ask anything about your feedback.
              </p>

              <textarea
                value={faqMessage}
                onChange={(e) => setFaqMessage(e.target.value)}
                rows={4}
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "50px",
                  borderRadius: "12px",
                  padding: "10px",
                  border: "1px solid #ccc",
                  marginTop: "15px",
                  marginBottom: "10px",
                  resize: "none",
                }}
                placeholder="Type your question here..."
              />
              <br />
              <Button
                onClick={handleSend}
                style={{
                  backgroundColor: "#030303ff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 25px",
                  color: "#fff",
                  boxShadow:
                    "0 0 8px #e3ccd8ff, 0 0 16px #211f20ff, 0 0 24px #cebcc5ff",
                  transition: "box-shadow 0.6s ease-in-out",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 0 12px #ff66cc, 0 0 24px #ff66cc, 0 0 36px #ff66cc")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 0 8px #d4197a, 0 0 16px #d4197a, 0 0 24px #d4197a")
                }
              >
                Send
              </Button>
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <br />
        <br />
      </Container>

      <style>{`
        .faq-accordion {
          margin: 0 auto;
          border-radius: 12px;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          color: black;
          background-color: #fff;
        }

        .accordion-item {
          border: none;
          background-color: #fff;
          transition: all 0.3s ease;
          color: black;
          margin-top: 15px;
        }

        .accordion-item:first-child {
          margin-top: 0;
        }

        .accordion-item.active {
          background-color: #fce4f6;
        }

        .accordion-header {
          background-color: #fff;
          color: black;
          font-weight: 500;
          padding: 16px 20px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: background 0.3s ease;
        }

        .accordion-item.active .accordion-header {
          background-color: #fce4f6;
        }

        .accordion-header:hover {
          background-color: #f0f0f0;
        }

        .accordion-item.active .accordion-header:hover {
          background-color: #fce4f6;
        }

        .accordion-body {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease, padding 0.4s ease;
          background-color: #fff;
        }

        .accordion-body.open {
          max-height: 500px;
          background-color: #fce4f6;
        }

        .accordion-content {
          padding: 16px 20px;
          color: black;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
        }

        .faq-icon {
  font-size: 18px; /* ✅ slightly larger for perfect centering */
  font-weight: bold;
  background-color: #E91E63;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex; /* ✅ ensures perfect centering */
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  line-height: 0; /* ✅ remove vertical offset */
  vertical-align: middle;
  transition: all 0.3s ease;
}

      `}</style>
    </section>
  );
};

export default Faq;